export const urlWithSlash = (url: string) => {
    return url.endsWith('/') ? url : url + '/'
}
